export default "__VITE_ASSET__23d8204e__"